import React from 'react'
import ButtonProps from '../../interfaces/ButtonProps'

const BackButton: React.FC<ButtonProps> = ({color, className, onClickFunc}) => {
  return (
    <button onClick={onClickFunc} className={className}/*disabled={currentIndex === 0}*/>
      <svg /*width="75" height="75"*/ viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M43.2358 31.74H20.2438M20.2438 31.74L30.3028 21.681M20.2438 31.74L30.3028 41.799" stroke={color || "#000"} strokeWidth="4.311" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M31.74 60.48C15.8675 60.48 2.99998 47.6125 2.99998 31.74C2.99998 15.8673 15.8675 3 31.74 3C47.6127 3 60.48 15.8673 60.48 31.74C60.48 47.6125 47.6127 60.48 31.74 60.48Z" stroke={color || "#000"} strokeWidth="4.311" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  )
}

export default BackButton;